export default {
	name: 'Nazwa użytkowanika',
	nameError: 'Wymagana jest nazwa użytkownika.',
	email: 'Adres e-mail',
	emailRequiredError: 'Adres e-mail jest wymagany.',
	emailInvalidError: 'Nieprawidłowy adres e-mail.',
	phone: 'Numer telefonu (opcjonalnie)',
	phoneError: 'Nieprawidłowy numer telefonu.',
	title: 'Powiadom mnie, gdy wymagany rozmiar boksu będzie dostępny.',
	boxButton: 'Skrzynka wniosków',
	sendButton: 'Wysłane',
	privacyPolicy: 'Zapoznałem się i akceptuję politykę prywatności.',
	privacyPolicyError: 'Prosimy o zaakceptowanie naszej polityki prywatności.',
};